module.exports = __webpack_public_path__ + "static/media/ico-confirm.690d4cd2.svg";